// extracted by mini-css-extract-plugin
export default {"background":"ProgressBar_background__9Qv2C","bar":"ProgressBar_bar__iBZh-"};